import React, {useEffect, useRef, useState, useContext} from 'react';
import styles from './TeleOp.module.css';
import VideoFeed from './VideoFeed';
import InfoBox from './InfoBox';
import { useLocation} from "react-router-dom";
import { SwapMainAppContext } from "../../context/SwapMainAppContext";
import TeleOpRightPanel from "./TeleOpRightPanel";
import useBackgroundColorChange from '../../utils/useBackgroundColorChange';
// Right panel now hosts tabs for Leaderboard and Live Chat


const GlobalLive = () => {
    const wsRef = useRef(null);
    // Youtube stream video id
    // https://www.youtube.com/watch?v=XXXXXXXXXXX
    const { videoId, globalLiveRobotId } = useContext(SwapMainAppContext);
    const robotId = globalLiveRobotId;
    const location = useLocation();
    useBackgroundColorChange();  // change the background color for the new design

    useEffect(() => {
        const pingInterval = setInterval(() => {
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
                wsRef.current.send(JSON.stringify({type: 'ping'}));
            }
        }, 30000);

        return () => clearInterval(pingInterval);
    }, []);

    return (
        <div className={`${styles.container} ${styles.globalContainer}`}>
            <div className={styles.liveControlBackground}></div>
            <div className={styles.mainContent}>
                {
                    location.pathname === '/live-control' && (
                        <h1 className={styles.title}>Live: Robot Control Center</h1>
                    )
                }
                <VideoFeed
                    robotId={robotId}
                    global_live={true}
                />
            </div>
            <div className={styles.rightColumn}>
                <InfoBox robotId={robotId}/>
                {/* Right panel tabs render Leaderboard or Live Chat */}
                <TeleOpRightPanel
                    robotId={robotId}
                    leftPanel={'leaderboard'}
                    globalLive
                />
            </div>
           
        </div>
    );
};

export default GlobalLive;
